import React from 'react';

import { FillInBlankForm } from './fillInBlankForm';

interface EditFillInBlankProps {
  action: (data: any) => void;
  isGrammar?: boolean;
  questionState: {
    blankAllowed?: boolean;
    blankByBlankGrading?: any;
    caseInsensitive?: boolean;
    conceptID?: string;
    cues: string;
    cuesLabel?: string;
    flag?: string;
    instructions?: string;
    prompt: string;
    ruleDescription?: string;
  };
}

export const EditFillInBlank: React.FC<EditFillInBlankProps> = ({ action, isGrammar, questionState }) => {
  return (
    <FillInBlankForm
      action={action}
      editing={true}
      isGrammar={isGrammar}
      state={questionState}
    />
  );
};
